<template>
  <v-autocomplete
    v-model="currentUser"
    :items="users"
    :loading="isLoadingUsers"
    :search-input.sync="userSearchString"
    :dark="dark"
    :solo-inverted="dark"
    flat
    prepend-inner-icon="search"
    label="Search by user id"
    no-filter
    hide-details
  >
    <template v-slot:selection="{item}">
      <v-chip
        :color="dark ? 'success' : 'primary'"
        text-color="white"
        selected
        close
        @input="onUserSelect(null)"
      >
        <v-avatar>
          <v-icon>account_circle</v-icon>
        </v-avatar>
        {{ currentUser.first_name }} {{ currentUser.last_name }}
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      <template>
        <v-list-tile
          class="ident-user-menu-item"
          @click="onUserSelect(item)"
        >
          <v-list-tile-avatar color="info">
            <span class="white--text">
              {{ item.first_name[0] }}
              {{ item.last_name[0] }}
            </span>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>{{ item.first_name }} {{ item.last_name }}</strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <strong>id:</strong>{{ item.id }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              <strong>email:</strong>{{ item.email }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>

/**
 * This autocomplete component triggers a user search
 * Its controlled through props so that the main ident view updates and handles the store
 */

import _ from 'lodash';

export default {
  name: 'IdentUserSearch',
  props: {
    onUserSelect: {
      type: Function,
      required: true,
    },
    isLoadingUserDetail: {
      type: Boolean,
      required: true,
    },
    currentUser: {
      type: Object,
      default: null,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      userSearchString: '',
      userResults: [],
      isLoadingUsers: false,
    };
  },

  computed: {
    users() {
      return this.currentUser
        ? [this.currentUser]
        : this.userResults;
    },
  },

  watch: {
    userSearchString: _.debounce(async function search(val) {
      const minLength = 3;

      if (parseInt(val, 0) > 0) {
        this.fetchUsers(val);
      } else if (!val || val.length < minLength) {
        // this.userResults = [];
      } else if (val && val !== this.currentUser) {
        this.fetchUsers(val);
      }
    }, 700),
  },

  methods: {
    fetchUsers(val) {
      this.isLoadingUsers = true;
      this.$store.dispatch('getOnboardingUserById', val).then((data) => {
        this.isLoadingUsers = false;
        const { userMetaData, cognitoUserPoolData } = data;

        const email = cognitoUserPoolData.UserAttributes.find(obj => obj.Name === 'email').Value;
        const { naturalUser } = userMetaData.data;

        const result = {
          id: userMetaData.user_id,
          first_name: naturalUser.firstName,
          last_name: naturalUser.lastName,
          email };

        this.userResults = [result];
      });
    },
  },
};
</script>

<style lang="scss" >
.ident-user-menu-item {
  .v-list__tile {
    padding: 8px 16px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ident/shared/IdentUserSearch.vue